import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { IInstallmentstModal } from './types';
import {
  StyledDialog,
  Content,
  Footer,
  CloseIconStyled,
  CloseBox,
  LeftContentWrapper,
  ScrollableCardsWrapper,
} from './styles';
import { HeadlineLarge } from 'v3/shared/typography/HeadlineLarge';
import { useTheme } from '@mui/material/styles';
import { PixRounded } from '@mui/icons-material';
import { IInstallment } from 'v3/services/interfaces/response';
import { InstallmentCard } from 'v3/shared/components/Cards/InstallmentCard';
import { useStoreSelector } from 'v3/data/store';
import { amountFormatter } from 'utils/formatters';
import { HeadlineMediumStyled } from 'v3/shared/typography/HeadlineMedium/styles';
import { TitleSmallBoldStyled } from 'v3/shared/typography/TitleSmall/styles';

export const InstallmentsModal: React.FC<IInstallmentstModal> = ({ open, setOpenModal, onConfirmAndOpenPix }) => {
  const { isMobile } = useBreakpoints();
  const theme = useTheme();

  const { itemsToPay, totalToPay, item } = useStoreSelector((store) => store.installments);

  return (
    <StyledDialog open={open} fullScreen={isMobile}>
      <Content>
        <CloseBox>
          <CloseIconStyled onClick={() => setOpenModal(false)} aria-label="Fechar modal" />
        </CloseBox>
        <HeadlineLarge color={theme.palette.common.white}>Parcelas selecionadas</HeadlineLarge>
        <ScrollableCardsWrapper>
          {itemsToPay.map((installment: IInstallment) => (
            <InstallmentCard key={installment.number} installment={installment} totalInstallments={item.installments.length} />
          ))}
        </ScrollableCardsWrapper>
      </Content>
      <Footer>
        <LeftContentWrapper>
          <TitleSmallBoldStyled>Total a pagar</TitleSmallBoldStyled>
          <HeadlineMediumStyled>{amountFormatter(totalToPay)}</HeadlineMediumStyled>
        </LeftContentWrapper>
        <FlexButton
          text="Pagar com Pix"
          size="small"
          startIcon={PixRounded}
          handleClick={onConfirmAndOpenPix}
        />
      </Footer>
    </StyledDialog>
  );
};